import { SVGProps } from "react"

export const NoDataIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 303 290"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g filter="url(#filter0_d_288_1405)">
			<circle cx="145.102" cy="145" r="125" fill="#F2F7F4" />
			<circle
				cx="145.102"
				cy="145"
				r="121.614"
				stroke="white"
				strokeWidth="6.77201"
			/>
		</g>
		<mask
			id="mask0_288_1405"
			style={{ maskType: "alpha" }}
			maskUnits="userSpaceOnUse"
			x="27"
			y="27"
			width="236"
			height="236"
		>
			<circle cx="145.102" cy="145" r="117.664" fill="white" />
		</mask>
		<g mask="url(#mask0_288_1405)">
			<mask
				id="mask1_288_1405"
				style={{ maskType: "alpha" }}
				maskUnits="userSpaceOnUse"
				x="54"
				y="88"
				width="182"
				height="182"
			>
				<path d="M54.5261 88.8488H235.677V270H54.5261V88.8488Z" fill="white" />
			</mask>
			<g mask="url(#mask1_288_1405)">
				<path
					d="M213.82 139.314L170.916 96.4093C169.11 94.7108 166.714 93.7821 164.235 93.8198C161.757 93.8575 159.39 94.8588 157.637 96.6114C155.883 98.3641 154.881 100.73 154.843 103.209C154.804 105.688 155.732 108.084 157.43 109.891L139.033 128.287L181.938 171.191L200.334 152.795C202.122 154.583 204.547 155.588 207.076 155.589C208.328 155.589 209.567 155.343 210.724 154.864C211.881 154.385 212.932 153.683 213.818 152.797C214.703 151.912 215.406 150.861 215.885 149.705C216.365 148.548 216.611 147.308 216.612 146.056C216.612 144.804 216.366 143.564 215.887 142.407C215.408 141.25 214.706 140.199 213.82 139.314Z"
					fill="#BECCC1"
				/>
				<path
					d="M164.171 93.616H92.6635C87.6062 93.616 82.7561 95.625 79.18 99.201C75.604 102.777 73.595 107.627 73.595 112.685V246.164C73.595 251.222 75.604 256.072 79.18 259.648C82.7561 263.224 87.6062 265.233 92.6635 265.233H197.541C202.598 265.233 207.448 263.224 211.024 259.648C214.6 256.072 216.609 251.222 216.609 246.164V146.054H173.705C168.938 146.054 164.171 141.287 164.171 136.52V93.616Z"
					fill="url(#paint0_linear_288_1405)"
				/>
				<path
					d="M164.171 93.6161H154.636V136.52C154.636 141.578 156.645 146.428 160.221 150.004C163.797 153.58 168.647 155.589 173.705 155.589H216.609V146.055H173.705C168.938 146.055 164.171 141.287 164.171 136.52V93.6161Z"
					fill="white"
				/>
				<path
					d="M140.335 146.664C140.335 147.928 139.833 149.14 138.939 150.034C138.045 150.928 136.832 151.431 135.568 151.431H97.4307C96.1664 151.431 94.9538 150.928 94.0598 150.034C93.1658 149.14 92.6636 147.928 92.6636 146.664C92.6636 145.399 93.1658 144.187 94.0598 143.293C94.9538 142.399 96.1664 141.896 97.4307 141.896H135.568C136.832 141.896 138.045 142.399 138.939 143.293C139.833 144.187 140.335 145.399 140.335 146.664Z"
					fill="white"
				/>
				<path
					d="M140.335 219.462C140.335 220.727 139.833 221.939 138.939 222.833C138.045 223.727 136.832 224.229 135.568 224.229H97.4307C96.1664 224.229 94.9538 223.727 94.0598 222.833C93.1658 221.939 92.6636 220.727 92.6636 219.462C92.6636 218.198 93.1658 216.985 94.0598 216.091C94.9538 215.197 96.1664 214.695 97.4307 214.695H135.568C136.832 214.695 138.045 215.197 138.939 216.091C139.833 216.985 140.335 218.198 140.335 219.462Z"
					fill="white"
				/>
				<path
					d="M197.541 169.801C197.541 171.066 197.038 172.278 196.144 173.172C195.25 174.066 194.038 174.568 192.773 174.568H97.4307C96.1664 174.568 94.9538 174.066 94.0598 173.172C93.1658 172.278 92.6636 171.066 92.6636 169.801C92.6636 168.537 93.1658 167.324 94.0598 166.43C94.9538 165.536 96.1664 165.034 97.4307 165.034H192.773C194.038 165.034 195.25 165.536 196.144 166.43C197.038 167.324 197.541 168.537 197.541 169.801Z"
					fill="white"
				/>
				<path
					d="M179.809 192.909C179.809 194.181 179.392 195.402 178.652 196.301C177.911 197.201 176.906 197.706 175.858 197.706H96.8515C95.8038 197.706 94.799 197.201 94.0581 196.301C93.3173 195.402 92.9011 194.181 92.9011 192.909C92.9011 191.637 93.3173 190.417 94.0581 189.517C94.799 188.618 95.8038 188.112 96.8515 188.112H175.858C176.906 188.112 177.911 188.618 178.652 189.517C179.392 190.417 179.809 191.637 179.809 192.909Z"
					fill="white"
				/>
			</g>
			<path
				d="M201.249 223.337L199.351 225.106L193.719 219.068L191.72 216.923L193.617 215.153L195.617 217.298L201.249 223.337Z"
				fill="#EBF5ED"
			/>
			<path
				d="M195.617 217.298C195.314 217.605 195.003 217.906 194.686 218.201C194.37 218.497 194.046 218.788 193.719 219.066L191.72 216.921L193.622 215.152L195.617 217.298ZM201.553 223.621C201.25 223.927 200.939 224.228 200.623 224.523C200.306 224.819 199.983 225.11 199.656 225.388L197.656 223.243L199.559 221.474L201.553 223.621Z"
				fill="#BECCC1"
			/>
			<path
				d="M203.49 195.173C203.271 201.362 201.221 207.347 197.602 212.372C193.983 217.397 188.956 221.236 183.155 223.406C177.355 225.575 171.042 225.977 165.014 224.56C158.985 223.144 153.512 219.973 149.284 215.447C143.619 209.372 140.599 201.296 140.888 192.994C141.177 184.692 144.752 176.845 150.826 171.179C163.453 159.399 183.313 160.089 195.093 172.72C197.908 175.721 200.099 179.251 201.541 183.105C202.982 186.959 203.645 191.061 203.49 195.173Z"
				fill="url(#paint1_linear_288_1405)"
			/>
			<path
				d="M197.641 194.981C197.412 201.574 194.633 207.82 189.89 212.405C185.147 216.99 178.81 219.555 172.214 219.561C171.913 219.561 171.61 219.556 171.306 219.545C169.724 219.491 168.151 219.291 166.606 218.948C163.664 218.295 160.864 217.118 158.338 215.475C156.592 214.337 154.991 212.991 153.571 211.466C149.017 206.518 146.605 199.97 146.861 193.25C147.117 186.531 150.021 180.185 154.938 175.599C159.855 171.012 166.387 168.556 173.108 168.768C179.83 168.979 186.194 171.841 190.813 176.728C191.832 177.818 192.753 178.996 193.567 180.246C195.212 182.77 196.39 185.568 197.046 188.509C197.518 190.632 197.718 192.807 197.641 194.981Z"
				fill="url(#paint2_linear_288_1405)"
			/>
			<path
				d="M180.613 180.462C176.498 178.126 171.623 177.52 167.061 178.778C162.499 180.035 158.623 183.052 156.285 187.167"
				stroke="white"
				strokeWidth="8.46501"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M224.647 249.551C223.576 250.553 222.163 251.11 220.696 251.107H220.49C219.731 251.084 218.984 250.909 218.292 250.595C217.6 250.281 216.978 249.833 216.46 249.277L195.153 227.249L203.629 219.339L224.932 241.355C225.979 242.481 226.536 243.976 226.483 245.512C226.429 247.048 225.769 248.5 224.647 249.551Z"
				fill="#BECCC1"
			/>
			<path
				d="M225.401 248.693C224.865 249.441 224.159 250.051 223.341 250.472C222.523 250.893 221.616 251.113 220.696 251.114H220.49C219.73 251.09 218.983 250.915 218.291 250.599C217.6 250.284 216.977 249.835 216.46 249.278L195.153 227.249L196.527 225.968L217.788 247.946C218.306 248.502 218.929 248.95 219.62 249.265C220.312 249.579 221.059 249.753 221.819 249.777H222.025C223.236 249.78 224.418 249.401 225.401 248.693Z"
				fill="#EBF5ED"
			/>
			<path
				d="M203.51 221.948L223.573 242.011"
				stroke="white"
				strokeWidth="1.693"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<g filter="url(#filter1_f_288_1405)">
			<circle
				cx="252.528"
				cy="82.359"
				r="27.3702"
				fill="#BECCC1"
				fillOpacity="0.7"
			/>
		</g>
		<circle
			cx="246.32"
			cy="76.1515"
			r="27.3702"
			fill="url(#paint3_linear_288_1405)"
		/>
		<path
			d="M254.033 69.8492L253.469 69.8492L254.033 69.8492C254.033 69.4751 253.885 69.1162 253.62 68.8516C253.356 68.587 252.997 68.4384 252.623 68.4384C252.248 68.4384 251.89 68.587 251.625 68.8516L246.038 74.4382L240.452 68.8516C240.187 68.587 239.828 68.4384 239.454 68.4384C239.08 68.4384 238.721 68.587 238.456 68.8516C238.192 69.1162 238.043 69.4751 238.043 69.8492L238.606 69.8492L238.043 69.8492C238.043 70.2234 238.192 70.5823 238.456 70.8468L244.043 76.4335L238.456 82.0201C238.192 82.2847 238.043 82.6435 238.043 83.0177C238.043 83.3919 238.192 83.7507 238.456 84.0153C238.721 84.2799 239.08 84.4285 239.454 84.4285C239.828 84.4285 240.187 84.2799 240.452 84.0153L246.038 78.4287L251.625 84.0153C251.89 84.2799 252.248 84.4285 252.623 84.4285C252.997 84.4285 253.356 84.2799 253.62 84.0153C253.885 83.7507 254.033 83.3919 254.033 83.0177C254.033 82.6435 253.885 82.2847 253.62 82.0201L248.034 76.4335L253.62 70.8468C253.885 70.5823 254.033 70.2234 254.033 69.8492Z"
			fill="white"
			stroke="white"
			strokeWidth="1.12867"
		/>
		<defs>
			<filter
				id="filter0_d_288_1405"
				x="0.101562"
				y="0"
				width="290"
				height="290"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="10" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.901961 0 0 0 0 0.941176 0 0 0 0 0.909804 0 0 0 0.6 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_288_1405"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_288_1405"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_f_288_1405"
				x="202.585"
				y="32.4154"
				width="99.8872"
				height="99.887"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="BackgroundImageFix"
					result="shape"
				/>
				<feGaussianBlur
					stdDeviation="11.2867"
					result="effect1_foregroundBlur_288_1405"
				/>
			</filter>
			<linearGradient
				id="paint0_linear_288_1405"
				x1="145.102"
				y1="265.233"
				x2="145.102"
				y2="93.616"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E6F0E8" />
				<stop offset="1" stopColor="#BECCC1" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_288_1405"
				x1="172.191"
				y1="162.776"
				x2="172.191"
				y2="225.391"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E6F0E8" />
				<stop offset="1" stopColor="#BECCC1" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_288_1405"
				x1="172.25"
				y1="168.755"
				x2="172.25"
				y2="219.561"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F0FFF3" />
				<stop offset="1" stopColor="white" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_288_1405"
				x1="246.32"
				y1="48.7812"
				x2="246.32"
				y2="103.522"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E6F0E8" />
				<stop offset="1" stopColor="#BECCC1" />
			</linearGradient>
		</defs>
	</svg>
)
